import { render, staticRenderFns } from "./CollectionMenu.vue?vue&type=template&id=23256419&scoped=true&"
import script from "./CollectionMenu.vue?vue&type=script&lang=ts&"
export * from "./CollectionMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionMenu.vue?vue&type=style&index=0&id=23256419&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23256419",
  null
  
)

export default component.exports